/**
 * Pre-fills the RFQ part field from the page URL (?part=...), so buyers who
 * click "Request a quote" on a product or an empty search don't retype it.
 * Never overwrites a value the buyer (or a re-rendered form) already has.
 */
class SRfqPrefill extends HTMLElement {
  connectedCallback() {
    const field = this.querySelector('textarea, input');
    if (!field || field.value.trim() !== '') return;

    const param = this.getAttribute('param') || 'part';
    const value = new URLSearchParams(window.location.search).get(param);
    if (!value) return;

    field.value = value.trim().slice(0, 500);
  }
}

if (!customElements.get('s-rfq-prefill')) customElements.define('s-rfq-prefill', SRfqPrefill);
